import {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useRef
} from 'react'
import Typography from '@mui/material/Typography'
import ClockIcon from '../../../images/clockIcon.svg'
import {
  Box,
  Button,
  Dialog,
  FormControl,
  InputAdornment,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  useMediaQuery
} from '@mui/material'
import { useStyles } from '../style'
import { useParams } from 'react-router-dom'
import { Message } from '../../../components/Message/Message'
import {
  availableTimeSlots,
  eventDetail,
  bookTimeSlotsLive,
  getBooking,
  updateEventInfo,
  selectedSlotRoomId,
  updatePublicationDate,
  bookedSlotsPerDate
} from '../../../services/EventService'
import { useWebcast } from '../../../hooks/useWebcast'
import EditSpeakerAndStaffSupport from '../EditSpeakerAndStaffSupport'

import moment from 'moment'
import { appTheme } from '../../../theme'
import Slots from '../Slots'
import { MobileDatePickerComponent } from '../../../components/MobileDatePicker/MobileDatePickerComponent'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
      width: 172
    }
  }
}

const EditSeriesEvent = forwardRef(({ increaseEventsCount, saveMainBooking }: any, ref: any) => {
  const [openAddEvent, setOpenAddEvent] = useState(false)
  useImperativeHandle(ref, () => ({
    updateEvent: (eventData: any, index: number) => {
      setOpenAddEvent(true)
      setEvent(eventData)
      setEditEventId(eventData.id)
      setEventIndex(index)
      setErrors({ title: '', summary: '' })
      if(id === eventData.id.toString()){
        loadLocalStorageBookingData(eventData.id) 
      }
    }
  }))

  const fullScreen = useMediaQuery(appTheme.breakpoints.down('md'))
  const [openLiveEventSlot, setOpenLiveEventSlot] = useState(false)
  const staffRef = useRef<any>(null)

  const classes = useStyles()

  // Time Picker logics end
  const [selectedLiveSlot, setLiveSlot] = useState<string>('')
  const [selectedDrySlot, setDrySlot] = useState<string>('')
  const [editEventId, setEditEventId] = useState(0)
  const [eventIndex, setEventIndex] = useState(0)

  const clickLiveSlot = (slot: any) => {
    setErrorMessage(false)
    setLiveSlot(slot)
  }

  const convertTimeIntoMinutes = (time: string) => {
    if (time === '') {
      return 0
    }
    let timeArray = time.split(' ')
    let timeStr = timeArray[0]
    let timePMAM = timeArray[1]
    let timeMinutesArray = timeStr.split(':')
    let hours = timeMinutesArray[0]
    let minutes = timeMinutesArray[1]
    let totalMinutes = 0
    if (timePMAM === 'AM') {
      totalMinutes = Number(hours) * 60 + Number(minutes)
    } else if (timePMAM === 'PM' && Number(hours) === 12) {
      totalMinutes = Number(hours) * 60 + Number(minutes)
    } else {
      totalMinutes = Number(hours) * 60 + Number(minutes) + 12 * 60
    }
    return totalMinutes
  }

  const convertMinutesIntoTime = (time: number) => {
    if (time === 0) {
      return 0
    }
    let period = 'AM'
    let hours = Math.floor(time / 60)
    let minutes: any = Math.floor(time % 60)
    if (minutes === 0) {
      minutes = '00'
    }
    if (hours > 11) {
      period = 'PM'
    }
    if (hours > 12) {
      hours = hours - 12
    }
    let timeSlot = `${hours}:${minutes} ${period}`
    return timeSlot
  }

  const [title, setTitle] = useState('')
  const [summary, setSummary] = useState('')

  const [showErrorMessage, setErrorMessage] = useState(false)
  const [validationMessage, setValidationMessage] = useState('')
  const [showSuccessMessage, setShowSuccesMessage] = useState(false)
  const [successMessage, setSuccesMessage] = useState('')
  const [event, setEvent] = useState<any>({})
  const [audience, setAudience] = useState(500)
  const [liveSlotsPerDate, setLiveSlotsPerDate] = useState({})

  // Live Event Run Logic start
  const [liveDuration, setLiveDuration] = useState(30)
  const [liveTimeSlots, setLiveTimeSlots] = useState<string[]>([])
  const [eventLiveDate, setEventLiveDate] = useState<Date | null>(
    () => new Date()
  )
  const { minimumLiveDate, getMinimumPublicationDate } = useWebcast()
  // Event Dry Run Logic start
  const [dryDuration, setDryDuration] = useState(30)
  const [eventDryDate, setEventDryDate] = useState<Date | null>(
    () => new Date(eventLiveDate!)
  )

  const [publicationDate, setPublicationDate] = useState<Date | null>(
    () => new Date()
  )

  let minimumPublicationDate = getMinimumPublicationDate(eventLiveDate!, liveDuration)

  const [bookingCount, setBookingCount] = useState(0)
  const [bookingLoading, setBookingLoading] = useState(true)

  let { id } = useParams()

  const loadLocalStorageBookingData = (eventId: number)=>{
    let eventBookingDataStr: any = localStorage.getItem('bookingData');
    if(eventBookingDataStr !== null && eventBookingDataStr !== undefined){
      let eventBookingData = JSON.parse(eventBookingDataStr)
      if(id === eventId.toString()){
        setLiveDuration(eventBookingData.liveDuration)
        setEventLiveDate(eventBookingData.eventLiveDate)
        setLiveSlot(eventBookingData.selectedLiveSlot)
        setDryDuration(eventBookingData.dryDuration)
        setPublicationDate(eventBookingData.eventDryDate)
        setDrySlot(eventBookingData.selectedDrySlot)
      }
    }
  }
  
  const emptyBookingData = (booking:any, eventId: number)=>{
    if(booking.length === 0){
      setLiveDuration(30)
      setEventLiveDate(new Date())
      setLiveSlot('')
      setDryDuration(60)
      setPublicationDate(new Date(eventLiveDate!))
      setDrySlot('')
    }
  }
  

  useEffect(() => {
    setPublicationDate(publicationDate!)
  }, [publicationDate!])

  const displayServerError = () => {
    setValidationMessage('Internal server error')
    showErrorPopup()
  }

  const [errors, setErrors] = useState({ title: '', summary: '' })
  const handleChange = (event: any) => {
    let name = event.target.id
    let value = event.target.value
    if (name === 'title') {
      if (value.length >= 100) {
        setErrors({ ...errors, title: 'Character limit reached' })
      } else {
        setTitle(value)
        setErrors({ ...errors, title: '' })
      }
    }
    if (name === 'summary') {
      if (value.length >= 500) {
        setErrors({ ...errors, summary: 'Character limit reached' })
      } else {
        setSummary(value)
        setErrors({ ...errors, summary: '' })
      }
    }
  }

  const loadEventData = async () => {
    try {
      const { data } = await eventDetail(editEventId)
      if (data) {
        if (data.eventDetail.statusCode === 200) {
          if (data.eventDetail.data === null) {
            //navigate('/')
          } else {
            setEvent(data.eventDetail.data)
            setTitle(data.eventDetail.data.title)
            setSummary(data.eventDetail.data.summary)
            if (data.eventDetail.data.title.length >= 100) {
              setErrors(old => {
                return { ...old, title: 'Character limit reached' }
              })
            }

            if (data.eventDetail.data.summary.length >= 500) {
              setErrors(old => {
                return { ...old, summary: 'Character limit reached' }
              })
            }

            if (data.eventDetail.data.publicationDate !== null) {
              setPublicationDate(
                new Date(Number(data.eventDetail.data.publicationDate))
              )
            }

            if (data.eventDetail.data.overHundredParticipants) {
              setAudience(3000)
            }
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }
  const bookingLoad = async () => {
    try {
      setBookingLoading(true)
      setBookingCount(0)

      const { data } = await getBooking(editEventId)
      if (data) {
        if (data.booking.statusCode === 200 && data.booking.data.length !== 0) {
          const booking = data.booking.data
          if (booking[0]?.category === 'live') {
            setEventLiveDate(new Date(Number(booking[0].date)))
            setLiveDuration(booking[0].endTime - booking[0].startTime)
            let bookingSelectedStartTime: any = convertMinutesIntoTime(
              booking[0].startTime
            )
            setLiveSlot(bookingSelectedStartTime)
          }

          if (booking[1]?.category === 'live') {
            setEventLiveDate(new Date(Number(booking[1].date)))
            setLiveDuration(booking[1].endTime - booking[1].startTime)
            let bookingSelectedStartTime: any = convertMinutesIntoTime(
              booking[1].startTime
            )
            setLiveSlot(bookingSelectedStartTime)
          }
        }
        else{
          emptyBookingData(data.booking.data, editEventId)
        }
          
        setBookingLoading(false)
        setBookingCount(data.booking.data.length)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const loadTimeSlots = async (duration: number, category: string) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(eventDryDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    try {
      const { data } = await availableTimeSlots(editEventId, input)
      if (data) {
        if (data.availableTimeSlots.statusCode === 200) {
          if (category === 'live') {
            setLiveTimeSlots(data.availableTimeSlots.data)
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  const loadBookedSlotsPerDate = async (eventId: number, category: string) => {
    try {
      const { data } = await bookedSlotsPerDate(eventId, { audience, category })

      if (data.bookedSlotsPerDate.statusCode === 200) {
        setLiveSlotsPerDate(data.bookedSlotsPerDate.data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    loadEventData()
    loadTimeSlots(liveDuration, 'live')
    if(id === editEventId.toString()){
      loadLocalStorageBookingData(editEventId) 
    }
    else{
      bookingLoad()
    }

    if (editEventId) {
      loadBookedSlotsPerDate(Number(editEventId), 'live')
    }
  }, [editEventId])

  useEffect(() => {
    if (!bookingLoading && bookingCount === 0) {
      const nextDate = getNextAvailableDate(eventLiveDate, liveDuration)
      setEventLiveDate(nextDate)
      if (nextDate) {
        setPublicationDate(getMinimumPublicationDate(nextDate, liveDuration))
      }
    }
  }, [bookingLoading, liveSlotsPerDate])

  const showErrorPopup = () => {
    setErrorMessage(true)
    setTimeout(() => {
      setErrorMessage(false)
    }, 3000)
  }

  const showSuccessPopup = () => {
    setShowSuccesMessage(true)
    setTimeout(() => {
      setShowSuccesMessage(false)
      handleEventClose()
      window.location.reload()
    }, 3000)
  }

  const getNextAvailableDate = (date: Date | null, duration: number) => {
    if (!date) return null
    const blockedDates = getBlockedDates(duration)

    let minimumDate = moment(minimumLiveDate)
    let currentDate = moment(date)
    if (currentDate.isBefore(minimumDate)) currentDate = minimumDate
    while (true) {
      if (!blockedDates.includes(currentDate.format('YYYY-MM-DD'))) break
      currentDate = currentDate.add(currentDate.day() === 5 ? 3 : 1, 'day')
    }

    return currentDate.toDate()
  }

  const handleLiveDuration = async (event: SelectChangeEvent) => {
    if (+event.target.value === liveDuration) return

    setErrorMessage(false)
    setLiveDuration(parseInt(event.target.value))
    setLiveSlot('')
    setEventLiveDate(getNextAvailableDate(eventLiveDate, +event.target.value))
    await getTimeSlots(Number(event.target.value), 'live')
  }

  const getTimeSlots = async (duration: number, category: string) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(eventDryDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    try {
      const { data } = await availableTimeSlots(editEventId, input)
      if (data) {
        if (data.availableTimeSlots.statusCode === 200) {
          if (category === 'live') {
            setLiveTimeSlots(data.availableTimeSlots.data)
          }
        }
      }
    } catch (error) {
      displayServerError()
    }
  }

  useEffect(() => {
    getTimeSlots(Number(liveDuration), 'live')
  }, [eventLiveDate])

  const getSelectedSlotRoomId = async (
    selectedSlot: string,
    duration: number,
    category: string
  ) => {
    const input: any = {
      duration: duration,
      liveBookingDate: moment(eventLiveDate).format('YYYY-MM-DD'),
      dryBookingDate: moment(eventDryDate).format('YYYY-MM-DD'),
      audience: audience,
      category: category
    }
    let slotRoomId: any = 0

    try {
      const { data } = await selectedSlotRoomId(
        selectedSlot,
        editEventId,
        event.eventType,
        input
      )
      if (data) {
        if (data.selectedSlotRoomId.statusCode === 200) {
          if (category === 'live') {
            slotRoomId = data.selectedSlotRoomId.data.slotRoomId
          }
        }
      }
    } catch (error) {
      console.log(error)
    }
    return slotRoomId
  }

  const handleEventClose = () => {
    increaseEventsCount()
    setOpenAddEvent(false)
  }

  const updateSeriesEvent = async () => {
    try {
      const results = await updateEventInfo(editEventId, title, summary, '')
      const { data } = results
      if (data) {
        if (data.updateEvent.statusCode === 200) {
        } else {
          console.log(data.updateEventInfo.message)
        }
      } else {
        console.log('Server error')
      }
    } catch (error) {
      console.log(error)
    }
  }

  const eventPublicationDate = async (event: any) => {
    const input: any = {
      publicationDate: moment(publicationDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD')
    }
    try {
      await updatePublicationDate(event.id, input)
    } catch (error) {
    }
  }

  const nextClick = async () => {
    let liveStartTime = convertTimeIntoMinutes(selectedLiveSlot)
    let dryStartTime = convertTimeIntoMinutes(selectedDrySlot)

    if (title === '') {
      setValidationMessage('Please enter event title')
      showErrorPopup()
      setErrors({ ...errors, title: 'Please enter event title' })
      return
    }

    if (summary === '') {
      setValidationMessage('Please enter event summary')
      showErrorPopup()
      setErrors({ ...errors, summary: 'Please enter event summary' })
      return
    }

    if (liveDuration === 0) {
      setValidationMessage('Please select live duration')
      showErrorPopup()
      return
    }
    if (liveStartTime === 0) {
      setValidationMessage('Please select live start time')
      showErrorPopup()
      return
    }
    const input: any = {
      liveDuration: liveDuration,
      liveBookingDate: moment(eventLiveDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      liveStartTime: liveStartTime,
      dryDuration: dryDuration,
      dryBookingDate: moment(eventDryDate)
        .set({ hour: 0, minute: 0, second: 0 })
        .format('YYYY-MM-DD'),
      dryStartTime: dryStartTime,
      audience: audience
    }

    try {
      let dryRoomId = 0
      let liveRoomId = await getSelectedSlotRoomId(
        selectedLiveSlot,
        liveDuration,
        'live'
      )
      if (liveRoomId === 0) {
        setValidationMessage('Live Event room not available')
        showErrorPopup()
        return
      }

      let staffValidateMessage = await staffRef.current.validateNewStaff()
      if (staffValidateMessage !== '') {
        setValidationMessage(staffValidateMessage)
        showErrorPopup()
        return
      }

      await updateSeriesEvent()

      let staffCreateMessage = await staffRef.current.createNewStaff(
        editEventId
      )
      if (staffCreateMessage !== '') {
        setValidationMessage(staffCreateMessage)
        showErrorPopup()
        return
      }

      const { data } = await bookTimeSlotsLive(
        liveRoomId,
        dryRoomId,
        editEventId,
        input
      )
      if (data) {
        if (data.bookTimeSlotsLive.statusCode === 200) {
          await eventPublicationDate(event)
          await saveMainBooking()
          setSuccesMessage('Series event updated successfuly')
          showSuccessPopup()
        } else if (data.bookTimeSlotsLive.statusCode === 404) {
          setValidationMessage(data.bookTimeSlotsLive.message)
          showErrorPopup()
        } else {
          console.log(data.bookTimeSlotsLive.message)
          setValidationMessage('Internal server error')
          showErrorPopup()
        }
      } else {
        setValidationMessage('Internal server error')
        showErrorPopup()
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getBlockedDates = (duration?: number) => {
    let blockedDates: string[] = []

    Object.entries(liveSlotsPerDate).forEach((x: any) => {
      if (!x[1][duration || liveDuration]) blockedDates.push(x[0])
    })

    return blockedDates
  }

  return (
    <Dialog
      fullScreen={fullScreen}
      open={openAddEvent}
      onClose={handleEventClose}
    >
      <Box
        sx={{
          width: '667px',
          borderRadius: '12px !important',
          px: '32px',
          py: '20px',
          gap: '24px',
          background: '#FFFFFF',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {showErrorMessage && (
          <Message message={validationMessage} isError={true} />
        )}
        {showSuccessMessage && (
          <Message message={successMessage} isSuccess={true} />
        )}
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <Box
            sx={{
              width: '32px',
              height: '32px',
              borderRadius: '50%',
              border: '1px solid #E6E1E5',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '50px'
            }}
          >
            <Typography
              color='#79747E'
              fontSize='16px !important'
              sx={{ lineHight: '24px' }}
            >
              {eventIndex}
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: '23px !important',
              fontWeight: '700',
              lineHeight: '32px'
            }}
          >
            Series event info
          </Typography>
        </Box>

        <div>
          <TextField
            fullWidth
            id='title'
            label='Title'
            value={title}
            onChangeCapture={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            placeholder='Title'
            error={errors.title !== '' ? true : false}
            // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            //   setTitle(event.target.value)
            // }}
            sx={{
              '.MuiOutlinedInput-root.Mui-focused': {
                fieldset: { borderColor: '#006BD7' }
              },
              [`& fieldset`]: {
                borderRadius: '8px'
              }
            }}
          />
          <Box sx={{ display: 'flex' }}>
            <Typography
              sx={{
                color: '#D50000',
                flex: 1,
                fontSize: 12,
                ml: 1.5,
                textAlign: 'left'
              }}
            >
              {errors.title}
            </Typography>
            <Typography sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 12 }}>
              {title.length} / 100
            </Typography>
          </Box>
        </div>

        <div>
          <TextField
            fullWidth
            id='summary'
            label='Summary'
            multiline
            rows={4}
            value={summary}
            onChangeCapture={handleChange}
            required
            InputLabelProps={{ shrink: true }}
            placeholder='Summary'
            error={errors.summary !== '' ? true : false}
            // onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            //   setSummary(event.target.value)
            // }}
            sx={{
              '.MuiOutlinedInput-root.Mui-focused': {
                fieldset: { borderColor: '#006BD7' }
              },
              [`& fieldset`]: {
                borderRadius: '8px'
              }
            }}
          />
          <Box sx={{ display: 'flex' }}>
            <Typography
              sx={{
                color: '#D50000',
                flex: 1,
                fontSize: 12,
                ml: 1.5,
                textAlign: 'left'
              }}
            >
              {errors.summary}
            </Typography>
            <Typography sx={{ color: 'rgba(0, 0, 0, 0.6)', fontSize: 12 }}>
              {summary.length} / 500
            </Typography>
          </Box>
        </div>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '23px !important',
                fontWeight: '700',
                lineHeight: '32px'
              }}
            >
              Event Recording Date
            </Typography>
            <Box className={classes.datepickerWrapper} sx={{ mt: '10px' }}>
              <MobileDatePickerComponent
                minimumDate={minimumLiveDate}
                eventDate={eventLiveDate!}
                setEventDate={setEventLiveDate}
                setLiveSlot={setLiveSlot}
                setMinimumDryDate={(newRecordingDate: Date) =>
                  setPublicationDate(getMinimumPublicationDate(newRecordingDate, liveDuration))
                }
                blockedDates={getBlockedDates()}
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '23px !important',
                fontWeight: '700',
                lineHeight: '32px'
              }}
            >
              Event Recording Time
            </Typography>
            <FormControl
              sx={{
                minWidth: 225,
                width: '100%',
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                  {
                    borderColor: '#006BD7'
                  }
                // '& .MuiOutlinedInput-notchedOutline': {
                //   borderRadius: '8px'
                // }
              }}
              size='small'
            >
              <Select
                value={liveDuration.toString()}
                onChange={handleLiveDuration}
                MenuProps={MenuProps}
                sx={{ textAlign: 'left' }}
              >
                <MenuItem value={0} disabled>
                  Select Duration
                </MenuItem>
                <MenuItem value={30}>30 Minutes</MenuItem>
                <MenuItem value={60}>60 Minutes</MenuItem>
                <MenuItem value={90}>90 Minutes</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label='Time'
              InputProps={{
                startAdornment: (
                  <InputAdornment position='start'>
                    <Box component='img' src={ClockIcon} alt='Clock Icon' />
                  </InputAdornment>
                ),
                style: {
                  height: '40px',
                  width: '100%'
                }
              }}
              onClick={() => {
                setOpenLiveEventSlot(true)
              }}
              value={selectedLiveSlot}
              sx={{
                '.MuiOutlinedInput-root.Mui-focused': {
                  fieldset: { borderColor: '#006BD7' }
                },
                [`& fieldset`]: {
                  borderRadius: '4px'
                }
              }}
            />
            <Slots
              open={openLiveEventSlot}
              setOpen={setOpenLiveEventSlot}
              selectedSlot={selectedLiveSlot}
              availableSlots={liveTimeSlots}
              setSlot={clickLiveSlot}
            />
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between'
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              sx={{
                fontSize: '23px !important',
                fontWeight: '700',
                lineHeight: '32px'
              }}
            >
              Event Publication Date
            </Typography>
            <Box
              className={classes.datepickerWrapper}
              sx={{ mt: '10px', mb: '40px' }}
            >
              <MobileDatePickerComponent
                minimumDate={minimumPublicationDate}
                eventDate={publicationDate!}
                setEventDate={setPublicationDate}
                setDrySlot={setDrySlot}
              />
            </Box>
          </Box>
        </Box>

        <EditSpeakerAndStaffSupport
          editEventId={editEventId}
          ref={staffRef}
        ></EditSpeakerAndStaffSupport>

        <Box
          sx={{
            gap: '15px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center'
          }}
        >
          <Button
            onClick={nextClick}
            sx={{ fontSize: '14px !important', width: '65%' }}
            style={{
              backgroundColor: '#333333',
              borderRadius: '25px',
              height: '40px',
              color: '#FFFFFF',
              fontWeight: '500',
              lineHeight: '20px',
              textTransform: 'none'
            }}
          >
            Save
          </Button>

          <Button
            fullWidth
            variant='outlined'
            sx={{ fontSize: '14px !important', width: '65%' }}
            style={{
              borderRadius: '25px',
              height: '40px',
              fontWeight: '500',
              lineHeight: '20px',
              textTransform: 'none',

              border: '2px solid #333333'
            }}
            onClick={handleEventClose}
          >
            Exit
          </Button>
        </Box>
      </Box>
    </Dialog>
  )
})
export default EditSeriesEvent
